<template>
  <div>
    <div v-if="carregando == true" class="carregando">
      <img width="130px" :src="iconeCarregando" />
      <br />
      <br />Carregando...
    </div>
    <div class="box-interno">
      <div class="mobile-margin visible-xs"></div>
      <div class="page-header clear-filter">
        <div>
          <h3 class="title">Quem Somos</h3>
        </div>
      </div>
      <div class=" p-0">
        <div class="container">
          <div class="row">
            <!--div class="col-sx-12 col-md-4">
            <card>
              <h4 class="h1-seo">
                <i class="now-ui-icons ui-2_chat-round mr-3"></i>Fale Conosco
              </h4>
              <br />
              <formFalecom @busca="buscarDados" :interno="true"></formFalecom>
            </card>
          </div-->
            <div id="Resultados" class="col-sx-12 col-md-12 p-2">
              <div class="perguntas  mt-3 p-4">
                <div class>
                  <alert v-if="!texto" type="warning"
                    >Nenhum Texto encontrado!</alert
                  >
                  <div v-else class="text-left ">
                    <div v-html="texto.texto"></div>
                  </div>
                </div>
              </div>

              <div class="mb-5"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  Tabs,
  TabPane,
  Navbar,
  DropDown,
  Card,
  Collapse,
  CollapseItem,
  Alert,
} from '@/components';
import jwt from 'jsonwebtoken';
import moment from 'moment';
import service from './../services';
import storage from '../services/storage';
export default {
  name: 'profile',
  components: {
    Tabs,
    TabPane,
    Navbar,
    DropDown,
    Card,
    Collapse,
    CollapseItem,
    Alert,
  },
  data() {
    return {
      iconeCarregando: service.getEnvIconeCarregando(),
      carregando: false,
      decoded: {},
      filtro: {},
      texto: null,
    };
  },
  methods: {
    retornaidEmpresa() {
      const idEmpresa = storage.lerStorage('idEmpresa');
      return idEmpresa;
    },
    formataNota(nota) {
      var amarela = 'https://vetmark.s3.amazonaws.com/site/pegada-amarela.png';
      var cinza = 'https://vetmark.s3.amazonaws.com/site/pegada-cinza.png';

      if (!nota) nota = 5;
      else nota = parseInt(nota);
      var qtdAmarela = nota;
      var qtdCinza = 5 - nota;
      var str = '';
      for (let index = 0; index < qtdAmarela; index++) {
        str = str + `<img src="${amarela}">`;
      }
      for (let index = 0; index < qtdCinza; index++) {
        str = str + `<img src="${cinza}">`;
      }
      return str;
    },
    buscarDados() {
      this.carregando = true;

      service.getAll('Textos', {}, 'Listar/ativo?idEmpresa='+ this.retornaidEmpresa()).then(res => {
        res.data.forEach(element => {
          if (element.titulo == 'Quem Somos') {
            this.texto = element;
          }
        });

        //this.$scrollTo("#Resultados");
        this.carregando = false;
      });
    },
  },
  mounted() {
    this.buscarDados();
  },
};
</script>
<style scoped>
.profile-page .page-header,
.page-header {
  min-height: auto !important;
  height: auto !important;
}

.profile-page .title {
  margin-top: 0px;
}
</style>
